module.exports = __webpack_public_path__ + "img/logo_green.61fd6bb7.png";